import { render, staticRenderFns } from "./AppListPC.vue?vue&type=template&id=986c8df2&scoped=true"
import script from "./AppListPC.vue?vue&type=script&lang=js"
export * from "./AppListPC.vue?vue&type=script&lang=js"
import style0 from "./AppListPC.vue?vue&type=style&index=0&id=986c8df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986c8df2",
  null
  
)

export default component.exports